import { httpsCallable } from "firebase/functions";
import { functions } from "shared/api/firebase";
import { AdminRole } from "../types";

export type AdminResponse = {
  id: string;
  email: string;
  roles: AdminRole[];
};

const getAdmins = async (): Promise<AdminResponse[]> => {
  const fn = httpsCallable<void, AdminResponse[]>(functions, "getAdmins");
  const response = await fn();
  return response.data;
};

export default getAdmins;
